/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_SOWING_ITEM = {
  id: 'agro_eventos_sowing',
  screenId: 'agr-eve-sowing',
  label: 'Siembra',
  description: 'Registro del evento de siembra sobre una siembra/campaña.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Documentás cómo se sembró: tipo (directa o convencional), densidad, distancia entre semillas y tecnología. Primero elegí la siembra en el selector.',
      },
      {
        title: 'Lista',
        bullets: [
          'Columnas: Fecha, Tipo, Dist. semillas, Densidad/Ha, Tecnología, Notas.',
          'Botón + para alta; lápiz y tachito para editar o borrar.',
        ],
      },
      {
        title: 'Formulario',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra a la que pertenece el evento.' },
          { label: 'Fecha', description: 'Día del evento.' },
          { label: 'Tipo de siembra', description: 'Directa o Convencional.' },
          { label: 'Distancia entre semillas', description: 'Espaciamiento usado.' },
          { label: 'Densidad por Ha', description: 'Densidad de siembra por hectárea.' },
          { label: 'Tecnología usada', description: 'Híbrido, variedad o paquete tecnológico.' },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_IRRIGATION_ITEM = {
  id: 'agro_eventos_irrigation',
  screenId: 'agr-eve-irrigation',
  label: 'Riego',
  description: 'Métodos de riego (maestros) y registro de láminas aplicadas.',
  detail: {
    sections: [
      {
        title: 'Pestañas',
        bullets: [
          'Maestros — catálogo de métodos de riego (solo Nombre).',
          'Registro — láminas aplicadas a una siembra.',
        ],
      },
      {
        title: 'Registro — campos',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra regada.' },
          { label: 'Fecha', description: 'Día del riego.' },
          { label: 'Lámina aplicada (mm)', description: 'Milímetros de agua aplicados (obligatorio).' },
          { label: 'Método (opcional)', description: 'Método del maestro (pivote, goteo, etc.).' },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_STAGE_ITEM = {
  id: 'agro_eventos_stage_change',
  screenId: 'agr-eve-stage',
  label: 'Estado fisiológico',
  description: 'Marcá cuándo el cultivo alcanzó un estado (emergencia, floración, etc.).',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás el cambio de estado fisiológico de la siembra. Los estados se definen en Cultivos → Configuración.',
      },
      {
        title: 'Formulario',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra observada.' },
          { label: 'Fecha', description: 'Día en que se alcanzó el estado.' },
          { label: 'Estado alcanzado', description: 'Estado del ciclo del cultivo.' },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_FERTILIZATION_ITEM = {
  id: 'agro_eventos_fertilization',
  screenId: 'agr-eve-fertilization',
  label: 'Fertilización',
  description: 'Maestro de fertilizantes y aplicaciones con dosis; puede descontar stock.',
  detail: {
    sections: [
      {
        title: 'Pestañas',
        bullets: [
          'Maestros — fertilizantes (Nombre y composición/nutrientes).',
          'Registro — aplicaciones sobre una siembra.',
        ],
      },
      {
        title: 'Registro — campos',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra fertilizada.' },
          { label: 'Fecha', description: 'Día de la aplicación.' },
          { label: 'Fertilizante', description: 'Producto del maestro (obligatorio).' },
          { label: 'Dosis', description: 'Cantidad aplicada.' },
          { label: 'Unidad', description: 'kg/ha o kg (total).' },
          {
            label: 'Almacén (movimiento de stock)',
            description:
              'Si el fertilizante está vinculado a un artículo, elegí el almacén para descontar stock.',
          },
          {
            label: 'Cantidad consumida',
            description: 'Cantidad que sale de stock cuando hay vínculo con artículo.',
          },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_APPLICATION_ITEM = {
  id: 'agro_eventos_application',
  screenId: 'agr-eve-application',
  label: 'Aplicaciones',
  description: 'Fitosanitarios (herbicida, insecticida, fungicida) y aplicaciones en campo.',
  detail: {
    sections: [
      {
        title: 'Pestañas',
        bullets: [
          'Maestros — productos fitosanitarios (Nombre y Tipo: Fungicida, Insecticida o Herbicida).',
          'Registro — aplicaciones sobre la siembra.',
        ],
      },
      {
        title: 'Registro — campos',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra tratada.' },
          { label: 'Fecha', description: 'Día de la aplicación.' },
          { label: 'Producto', description: 'Fitosanitario del maestro (obligatorio).' },
          { label: 'Dosis', description: 'Cantidad aplicada.' },
          { label: 'Unidad', description: 'Unidad de la dosis (texto libre, ej. l/ha).' },
          { label: 'Objetivo', description: 'Malezas, plaga o enfermedad objetivo (opcional).' },
          {
            label: 'Almacén / cantidad consumida',
            description: 'Si el producto está vinculado a stock, elegí almacén y cantidad a descontar.',
          },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_MONITORING_ITEM = {
  id: 'agro_eventos_monitoring',
  screenId: 'agr-eve-monitoring',
  label: 'Monitoreos',
  description: 'Seguimiento de plagas, enfermedades, malezas y otros controles en la siembra.',
  detail: {
    sections: [
      {
        title: 'Pestañas principales',
        bullets: [
          'Plagas — insectos y ácaros.',
          'Enfermedades — hongos, bacterias y virus.',
          'Malezas — plantas competidoras.',
          'Otros — tipos de monitoreo libres, como antes (solo nombre).',
        ],
      },
      {
        title: 'Catálogo (plagas, enfermedades o malezas)',
        bullets: [
          'Tocá el botón + para dar de alta un nuevo ítem.',
          'Elegí el campo y el cultivo (si hay uno solo, ya viene elegido).',
          'Pedí sugerencias: el sistema propone los más comunes para esa zona y cultivo.',
          'Elegí uno (o escribí otro) y revisá los tratamientos sugeridos antes de guardar.',
          'Las fotos se buscan solas por el nombre científico; no se mandan fotos a la IA.',
          'Al tocar una fila del listado ves el detalle y los tratamientos, sin entrar a editar.',
        ],
      },
      {
        title: 'Monitoreos (registro)',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra que estás visitando.' },
          { label: 'Fecha', description: 'Día del monitoreo.' },
          { label: 'Organismo', description: 'Del catálogo (plaga, enfermedad o maleza según la pestaña; se muestran las del cultivo de esa siembra).' },
          { label: 'Incidencia (%)', description: 'Porcentaje observado (opcional).' },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
      {
        title: 'Otros',
        bullets: [
          'Maestros — tipos de monitoreo con solo un nombre.',
          'Registro — visitas u observaciones con incidencia opcional.',
          'Acá caen los tipos viejos que no son plaga, enfermedad ni maleza.',
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_WEATHER_ITEM = {
  id: 'agro_eventos_weather',
  screenId: 'agr-eve-weather',
  label: 'Eventos climáticos',
  description: 'Tipos climáticos (granizo, helada…) y registros con severidad y daño.',
  detail: {
    sections: [
      {
        title: 'Pestañas',
        bullets: [
          'Maestros — tipos de evento climático (Nombre).',
          'Registro — ocurrencias sobre la siembra.',
        ],
      },
      {
        title: 'Registro — campos',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra afectada.' },
          { label: 'Fecha', description: 'Día del evento.' },
          { label: 'Tipo de evento', description: 'Del maestro (obligatorio).' },
          { label: 'Severidad', description: 'Baja, Media o Alta.' },
          { label: 'Daño (%)', description: 'Porcentaje de daño estimado (opcional).' },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_CULTURAL_ITEM = {
  id: 'agro_eventos_cultural_task',
  screenId: 'agr-eve-cultural',
  label: 'Labores culturales',
  description: 'Catálogo de labores y registro de tareas hechas en la siembra.',
  detail: {
    sections: [
      {
        title: 'Pestañas',
        bullets: [
          'Maestros — labores (Nombre).',
          'Registro — qué labor se hizo y cuándo.',
        ],
      },
      {
        title: 'Registro — campos',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra trabajada.' },
          { label: 'Fecha', description: 'Día de la labor.' },
          { label: 'Labor', description: 'Del maestro (obligatorio).' },
          { label: 'Mano de obra', description: 'Empleado y horas. En cualquier tipo de evento. Esas horas se valorizan en Costos de campaña.' },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_EVE_HARVEST_ITEM = {
  id: 'agro_eventos_harvest',
  screenId: 'agr-eve-harvest',
  label: 'Cosecha',
  description: 'Registro de cosecha; puede sumar stock si el cultivo tiene artículo vinculado.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Cargás la cosecha de una siembra: cantidad, humedad y superficie cosechada. El rendimiento (kg/ha) se calcula solo. Si el cultivo tiene artículo de stock, elegís almacén y la cantidad entra al depósito.',
      },
      {
        title: 'Lista',
        bullets: [
          'Columnas: Fecha, Cant. cosechada, Rend. (kg/ha), Humedad (%), Sup. cosechada (ha), Notas.',
        ],
      },
      {
        title: 'Formulario',
        fields: [
          { label: 'Cultivo / siembra', description: 'Siembra cosechada.' },
          { label: 'Fecha', description: 'Día de la cosecha.' },
          { label: 'Cantidad cosechada', description: 'Cantidad total cosechada.' },
          { label: 'Humedad (%)', description: 'Humedad del grano (opcional).' },
          {
            label: 'Superficie cosechada (ha)',
            description:
              'Hectáreas efectivamente cosechadas (puede ser parcial). Sirve para calcular el rendimiento.',
          },
          {
            label: 'Rendimiento (kg/ha, calculado)',
            description: 'Se calcula solo a partir de cantidad y superficie; no se edita a mano.',
          },
          {
            label: 'Almacén',
            description: 'Si el cultivo tiene artículo vinculado, depósito donde ingresa la mercadería.',
          },
          { label: 'Notas', description: 'Observaciones.' },
        ],
      },
    ],
  },
}
